export const formatCursorHint = (timestamp: number): string => {
  const date = new Date(timestamp);
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });

  return `${date.getDate()} ${month} AT ${time}`;
};
